export default "__VITE_ASSET__DkZyOyte__"